const messages = {
  title: "INFORMATIE OVER PRODUCTEN  ",
  list: "",
  description:
    "Download hier de meest recente brochures en flyers van onze Bridgestone- en Firestone- banden.  ",
  brochureCategories: {
    products: "Producten",
    brand_and_solutions: "Merken & Oplossingen",
    season_and_promotions: "Seizoen & Promoties",
    format: "Formaat",
    cars_and_vans: "Personenwagen, SUV, Bestelwagen",
    summer: "Zomer",
    winter: "Winter",
    promotions: "Promoties",
    all_season: "Vier seizoenen",
    truck_and_buses: "Vrachtwagens & Bussen",
    motorcycle: "Motorfiets",
    agriculture: "Landbouw",
    construction_machinery: "Bouwmachines",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialen",
    brochures: "Productbrochures",
    price_list: "Prijslijsten",
    materials: "Documenten",
    video_in_store: "Video met ondertiteling",
    video_online: "Video zonder ondertiteling",
    banner_website: "Banner",
    banner_social_media: "Sociale Media",
    logos: "Logo’s",
  },
  searchMedia: "Zoekterm invoeren",
  searchResults: "Zoekresultaten",
};

export default {
  messages,
};
